import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { Presentation } from "../../../../core/gameflow/controller/Presentation";
import { GameSetting } from "../../../../core/setting/GameSetting";
import { Helper } from "../../../../core/utils/Helper";
import { SoundConfig } from "../../../config/sound/SoundConfig";
import { SoundManager } from "../../../config/sound/SoundManager";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { SanSpriteSymbol } from "../../../engine/Symbol/SanSpriteSymbol";
import { BigWinPosterState } from "../../../modules/poster/BigWinPoster";
import { Revealer } from "../../../modules/revealer/Revealer";
import { RevealerManager } from "../../../modules/revealer/RevealerManager";
import { SplashWindows } from "../../../modules/splashScreen/SplashWindows";
import { SanQuentin2 } from "../../../SanQuentin2";
import { IBetWayWinData } from "../../../server/base/IData";
import { GameData } from "../../../server/data/GameData";
import { gsap } from "gsap";
import { SpinePlayer } from '../../../../core/displayobject/SpinePlayer';

export class IdlePresentation extends Presentation {

    protected playIntroRestore: boolean = false;

    protected _gameData: GameData;

    private static _idleTimeline: gsap.core.Timeline;

    private static raceShit:boolean = false;

    setInitData(data: GameData): void {
        this.setGameData(data);
    }

    public createPresentation() {
        if (!this._gameData.Win.isWinBelowStake()) {
            this.addWinCountUpToTimeline()
        }

        this.setPlayable(false);
    }

    protected addWinCountUpToTimeline(): void {
        // Initialize the idle timeline with an infinite repeat
        IdlePresentation._idleTimeline = Helper.setTimeline(IdlePresentation._idleTimeline, { repeat: -1 });
        IdlePresentation.raceShit = true;
        // Constants for delay and duration
        const delay: number = 3;
        const duration: number = 1.2;

        // SpinePlayer.fetchDuration("MPs","m1")
        // SanQuentin2.overlay.playSpine(this,"MPs",{animation:"animation",skinType:"m"+this.symName[1],duration:durr})
        const animationDurr: number = SpinePlayer.fetchDuration("MPs","animation");// 0.6;
        const animationGroupOffset: number = SpinePlayer.fetchDuration("MPs","animation");

        // Add initial delay to the timeline
        IdlePresentation._idleTimeline.to(this, { duration: delay });

        // Retrieve win groups data
        const winGrps: IBetWayWinData[] = this._gameData.Win.betWayWins!;
        const reels = this._gameData.Reel.reels;
        let triggerTime: number = delay;

        // Iterate over each win group
        for (const winData of winGrps) {
            // Iterate over each reel
            for (let reel = 0; reel < reels.length; reel++) {
                const posRow: boolean[] = winData.reelWinPositions[reel];
                const reelInstance = SanEngineManager.getReel(reel);

                // Add counter callback
                IdlePresentation._idleTimeline.add(() => {
                    SanQuentin2.counter.setValue(winData.amount, winData.numberOfCombinations);
                }, triggerTime);

                // Iterate over each row in the reel
                for (let row = 0; row < posRow.length; row++) {
                    const isAWin = posRow[row];
                    const sym = reelInstance.getSymbol(row - 1);

                    // Check if the position is on a Bar Top/Bot Position
                    if (row === 0 || row === posRow.length - 1) {
                        const bar = row === 0 ? RevealerManager.getTopBar(reel) : RevealerManager.getBotBar(reel);
                        IdlePresentation._idleTimeline.add(() => {
                            bar.PlayIdle(isAWin, animationDurr);
                        }, triggerTime);
                    } else if (sym) {
                        IdlePresentation._idleTimeline.add(() => {
                            sym.PlayIdle(isAWin, animationDurr);
                        }, triggerTime);
                    }
                }
            }
            triggerTime += animationGroupOffset;
        }

        // If there are multiple win groups, handle the combined win data
        if (winGrps.length > 1) {
            const combinedWinData = this._gameData.Win.allBetWayWinData;

            IdlePresentation._idleTimeline.add(() => {
                SanQuentin2.counter.setValue(this._gameData.Win.singleWin, this._gameData.Win.totalWinCombination);
            }, triggerTime);

            // Iterate over each reel for combined win data
            for (let reel = 0; reel < reels.length; reel++) {
                const posRow: boolean[] = combinedWinData.reelWinPositions[reel];
                const reelInstance = SanEngineManager.getReel(reel);

                for (let row = 0; row < posRow.length; row++) {
                    const isAWin = posRow[row];

                    // Check if the position is on a Bar Top/Bot Position
                    if (isAWin && (row === 0 || row === posRow.length - 1)) {
                        const bar = row === 0 ? RevealerManager.getTopBar(reel) : RevealerManager.getBotBar(reel);
                        IdlePresentation._idleTimeline.add(() => {
                            bar.PlayIdle(isAWin, animationDurr);
                        }, triggerTime);
                    } else {
                        IdlePresentation._idleTimeline.add(() => {
                            reelInstance.getSymbol(row - 1)!.PlayIdle(isAWin, animationDurr);
                        }, triggerTime);
                    }
                }
            }
        }

        // Add final animations and callbacks to the timeline
        IdlePresentation._idleTimeline.to(this, { duration: duration });
        IdlePresentation._idleTimeline.add(() => {
            SanEngineManager.RSAll((rc, s) => s.markNonWin(false, undefined, duration / 2));
            RevealerManager.getAllBars().forEach(rev => rev.markNonWin(false, undefined, duration / 2));
            SanQuentin2.counter.stop(undefined, duration / 2, 0, true);
        });
        IdlePresentation._idleTimeline.to(this, { duration: duration / 2 });
        IdlePresentation._idleTimeline.play();
    }

    public static DisableNormalIdle(): void {
        if (IdlePresentation.raceShit || (this._idleTimeline && this._idleTimeline.isActive())) {
            this._idleTimeline = Helper.setTimeline(this._idleTimeline!, undefined, false);
            IdlePresentation.raceShit = false;
            SanQuentin2.counter.stop(undefined, undefined, 0, true);
            SanEngineManager.RSAll((rc, sym) => { sym.stopWin(0.2) })
            RevealerManager.getAllBars().forEach(rev => {
                rev.stopWin(0.2);
            });
        }
    }

    done(): void {
    }
}